import { fromJS, Record } from 'immutable';

export const creditsRecord = new Record({
  byId: fromJS({}),
  allIds: fromJS([]),
  byProjectId: fromJS({}),
  byInstanceId: fromJS({})
});

export default creditsRecord();
